module.exports = __webpack_public_path__ + "media/newstyle/images/icon-ebook-a3283e2d5b31f96d479066c9ecf2e553.svg";